import { create } from "zustand";

const useFilterStore = create((set) => ({
  filterDate: {
    startDate: "",
    endDate: "",
  },
  setFilterDate: (payload) =>
    set((state) => ({
      ...state,
      filterDate: payload,
    })),

  tractionData: [],
  setTractionData: (payload) =>
    set((state) => ({ ...state, tractionData: payload })),
}));

export default useFilterStore;

